import React from 'react';
import { Box } from '../Box';
import { Flex } from '../Flex';
export function Coupon(props) {
    var _a, _b, _c, _d;
    const { style, bg = '#fff', splitBoxStyle, splitNum = 8, splitColor, splitStyle, borderColor, roundColor, roundBgColor = '#fff', rountTopStyle, rountBottomStyle, roundSize = 8, leftStyle, leftNode, rightStyle, rightNode, } = props;
    return (React.createElement(Flex, { flex: 'flexRowBtw', bs: { w: '100%', h: 68, borderRadius: 8 }, style: style },
        React.createElement(Flex, { flex: 'flexCenter', style: [
                { flex: 1, height: '100%' },
                {
                    backgroundColor: bg,
                    borderWidth: borderColor ? 1 : 0,
                    borderColor,
                    borderRightWidth: 0,
                    borderTopLeftRadius: (_a = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _a !== void 0 ? _a : 8,
                    borderBottomLeftRadius: (_b = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _b !== void 0 ? _b : 8,
                },
                leftStyle,
            ] }, leftNode),
        React.createElement(Flex, { flex: 'flexColBtw', bs: {
                w: roundSize + 4,
                bg,
                ml: -1,
                alignItems: 'center',
                h: '100%',
            }, style: splitBoxStyle },
            React.createElement(Box, { style: [
                    {
                        width: roundSize + 4,
                        height: roundSize,
                        borderTopLeftRadius: 0,
                        borderTopRightRadius: 0,
                        borderBottomLeftRadius: roundSize,
                        borderBottomRightRadius: roundSize,
                        borderColor: roundColor || borderColor || splitColor || bg,
                        borderRightWidth: 1,
                        borderBottomWidth: 1,
                        borderLeftWidth: 1,
                        borderTopWidth: 0,
                        backgroundColor: roundBgColor,
                    },
                    rountTopStyle,
                ] }),
            React.createElement(Box, { bs: {
                    flex: 1,
                    justifyContent: 'space-between',
                } }, new Array(splitNum).fill(0).map(() => {
                return (React.createElement(Box, { bs: {
                        w: 2,
                        h: 3,
                        bg: splitColor ||
                            borderColor ||
                            roundBgColor,
                    }, style: splitStyle }));
            })),
            React.createElement(Box, { style: [
                    {
                        width: roundSize + 4,
                        height: roundSize,
                        borderTopLeftRadius: roundSize,
                        borderTopRightRadius: roundSize,
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        borderColor: roundColor || borderColor || splitColor || bg,
                        borderRightWidth: 1,
                        borderBottomWidth: 0,
                        borderLeftWidth: 1,
                        borderTopWidth: 1,
                        backgroundColor: roundBgColor,
                    },
                    rountBottomStyle,
                ] })),
        React.createElement(Flex, { flex: 'flexCenter', style: [
                { height: '100%' },
                {
                    backgroundColor: bg,
                    borderWidth: borderColor ? 1 : 0,
                    borderColor,
                    borderLeftWidth: 0,
                    borderTopRightRadius: (_c = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _c !== void 0 ? _c : 8,
                    borderBottomRightRadius: (_d = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _d !== void 0 ? _d : 8,
                },
                rightStyle,
            ] }, rightNode)));
}
